import React, { useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import EDImage from '../../../../../BaseComponents/Image/EDImage';
import EDDialog from '../../../../../BaseComponents/Dialog/EDDialog';
import { getDocumentUrl } from '../../../../../Components/Documents/Documents';
import ZoomableImageView from '../../../../../Components/ZoomableImage/ZoomableImageView';

interface IProps {
  blobId: string;
  alt?: string;
  style?: React.CSSProperties;
  wrapperStyle?: React.CSSProperties;
  dialogTitle?: string;
  onImageLoad?: () => void;
  onImageError?: () => void;
}

const useStyles = makeStyles()({
  imageWrapper: {
    cursor: 'pointer',
    display: 'inline-block',
  },
  dialogPaper: {
    width: '100%',
  },
  fullImage: {
    objectFit: 'contain',
    objectPosition: '50% 50%',
    height: 'inherit',
    width: 'inherit',
  },
});

const BildViewer: React.FC<IProps> = ({
  blobId,
  alt = 'Foto',
  style,
  wrapperStyle,
  dialogTitle = 'Foto',
  onImageLoad,
  onImageError,
}) => {
  const { classes } = useStyles();
  const [open, setOpen] = useState(false);
  const url = getDocumentUrl(blobId);

  return (
    <>
      <div
        className={classes.imageWrapper}
        style={wrapperStyle}
        onClick={() => setOpen(true)}
        role="button"
        tabIndex={0}
        onKeyDown={e => e.key === 'Enter' && setOpen(true)}
        aria-label={`Öppna ${alt} i fullskärm`}
      >
        <EDImage
          src={url}
          alt={alt}
          style={style}
          onLoad={onImageLoad}
          onError={onImageError}
        />
      </div>

      <EDDialog
        title={dialogTitle}
        open={open}
        onClose={() => setOpen(false)}
        footerActions={[{ label: 'Stäng', onClick: () => setOpen(false) }]}
        fullHeight
        classes={{ paper: classes.dialogPaper }}
        maxWidth="lg"
      >
        <ZoomableImageView
          isImage
          title={dialogTitle}
          imageCount={1}
          imageIndex={0}
          noFullscreenToggle={false}
          extraBottomPadding={false}
          showCenteredImageToggle={false}
          useWheelToScroll={false}
          previousImage={() => {}}
          nextImage={() => {}}
          navHeader={dialogTitle}
        >
          <img className={classes.fullImage} src={url} alt={alt} />
        </ZoomableImageView>
      </EDDialog>
    </>
  );
};

export default BildViewer;
